import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import User from './user-dropdown/UserDropdown';

const HeaderNoSidebar = () => {
  const [t] = useTranslation();
  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light cce-no-sidebar cce-mobile-header-no-sidebar elevation-1">
      <div className="mr-1 cce-no-sidebar-logo">CCE Data Portal</div>
      {/* Left navbar links */}
      <ul className="navbar-nav mx-auto">
        <li className="nav-item">
          <Link to="/reporter" className="nav-link active">
            {t('header.label.about')}
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/activities" className="nav-link">
            {t('header.label.dataPortal')}
          </Link>
        </li>
      </ul>
      <ul className="navbar-nav ml-auto pr-lg-3 pr-0">
        <User />
      </ul>
    </nav>
  );
};

export default HeaderNoSidebar;
